/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';
enum Steps {
    TOS = 1,
    PRIV,
    ORG_INFO,
    ORG_ADD_INFO,
    INSURANCE
}

class WizardController {
    public static $inject = [
        '$http',
        '$state',
        'toaster',
        '$uibModal',
        'Login',
        'Orgs',
        'Employee',
        'bsLoadingOverlayService',
        'User',
        'Api',
    ];

    public agree = false;
    public agreePP = false;
    public currentStep = 0;
    public employee;
    public org;
    public industries = [];
    public num_emp = [];
    public legal_rep_type_options = ['In House Legal', 'External Law Firm', 'None Currently'];
    public ohs_rep_type_options = ['Onsite Medical Professional', 'HSE Manager', 'Office Manager', 'Other', 'None Currently'];
    public first_aid_training_options = ['Yes', 'No', 'I\'m not sure'];
    public broker_type_options = ['Yes', 'No'];
    public broker_name_options = ['Elite Insurance Brokers', 'Finsbury Associates', 'Links Insurance Brokers LLC', 'New shield Insurance Brokers LLC', 'Other'];
    public datePickerConfig;
    public providers = ['Allianz', 'AXA', 'Bupa', 'Daman', 'Dubai Insurance', 'Emarat Takaful', 'Metlife', 'NGI', 'Oman', 'Orient', 'RAK', 'Abu Dhabi National Insurance Co.', 'Abu Dhabi National Takaful Co.', 'Adam Jee Insurance', 'AETNA', 'Al Ain Ahlia Insurance Co.', 'Al Buhaira National Insurance Co.', 'Al Dhafra Insurance Company', 'Al Fujairah National Insurance Co.', 'Al Hilal Takaful Company', 'Al Ittihad Al Watani - General Insurance Society', 'Al Khazna Insurance Co.', 'Al Sagr National Insurance Co.', 'Al Wathba National Insurance Co.', 'Alliance Insurance', 'Arabia Insurance', 'Arabian Scandinavian Insurance Co.', 'Dar Al Takaful', 'Dubai Insurance Co.', 'Dubai Islamic Insurance & Reinsurance', 'Dubai National Insurance & Reinsurance', 'Emirates Insurance Company', 'Expacare', 'Friends Provident', 'Generali', 'Globalnet', 'Green Crescent Insurance Co.', 'Insurance House', 'Integraglobal', 'Iran Insurance', 'Islamic Arab Insurance Company - Salama', 'Jordan Insurance Company', 'Methaq Takaful Insurance Company', 'National Life and General Ins', 'National Takaful Company PSC - Watania', 'Noor Takaful Family', 'Other', 'Qatar Insurance & Reinsurance', 'Qatar Insurance Company', 'RSA Now Health', 'Saudi Arabia Insurance', 'Sharjah Insurance Co', 'Union Insurance Co.', 'United Insurance Company', 'Zurich'];
    public tmpDate;

    constructor(private $http: angular.IHttpService,
                private $state: ng.ui.IStateService,
                private toaster: any,
                private $uibModal: any,
                private Login: ILoginService,
                private Orgs: IOrgsService,
                private Employee: IEmpService,
                private bsLoadingOverlayService: IBsLoadingService,
                private User: IUserService,
                private Api: any) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.loadOrg();
        this.loadOrgDropdowns();
        this.Employee.loadEmployee(this.User.getCurrentUser().userData.id).then((response: Restangular.IResponse) => {
            this.employee = response;
        });

        this.datePickerConfig = {
            formatDay: 'd',
            formatDayTitle: 'MMM yyyy',
            showWeeks: false
        };

        angular.module('beneple.global').directive('directive', function ($timeout: any): any {
            return {
                link: function (scope: any, element: any, attr: any): any {
                    $timeout(function (): void {});
                }
            };
        });
    }

    private fillInOrgData(): void {
        // Prepare the default org
        if (!this.org.extra.details) {
            this.org.extra.details = {};
        }
        if (!this.org.extra.details.url) {
            this.org.extra.details.url = '';
        }
    }

    public loadOrg(): void {
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        this.Orgs.getOrg(undefined).then((response: Restangular.IResponse) => {
            this.org = response;
            if (!this.org.extra) {
                this.org.extra = {};
            }
            if (!this.org.extra.setup_wizard) { 
            this.org.extra.setup_wizard = {};
            }
            if (!this.org.extra.setup_wizard.current_step) {
                this.org.extra.setup_wizard = {
                current_step: 1,
                max_step: 1,
                completed: false
                };
            }
            if (this.org.extra.setup_wizard && this.org.extra.setup_wizard.current_step) {
                this.currentStep = this.org.extra.setup_wizard.current_step;
                if (this.org.extra.setup_wizard.current_step > 1) {
                    this.agree = true;
                }
                if (this.org.extra.setup_wizard.current_step > 1) {
                    this.agreePP = true;
                }
                if (this.currentStep === Steps.ORG_INFO) {
                    this.fillInOrgData();
                }
            }
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
        });
    }

    public loadOrgDropdowns(): void {
        this.Orgs.loadSchema().then((response: any) => {
            let schema: any = response.data;
            let industryEnums: any = schema.properties.details.properties.industry;
            for (var i: number = 0; i < industryEnums.enum.length; i++) {
                this.industries.push(industryEnums.enum[i]);
            }
            let numEmplEnums: any = schema.properties.details.properties.number_of_employees;
            for (var j: number = 0; j < numEmplEnums.enum.length; j++) {
                this.num_emp.push(numEmplEnums.enum[j]);
            }
        });
    }


    public goBack(): void {
        if (this.currentStep > 1) {
            this.org.extra.setup_wizard.current_step -= 1;
            this.currentStep = this.org.extra.setup_wizard.current_step;
            this.saveOrg();
        }
    }

    public validationError(field: any): boolean {
        this.toaster.pop('warning', 'All fields must be filled in. Field ' + field + ' is empty.');
        return false;
    }

    public validateForm(): boolean {
        if (!this.org.extra.setup_wizard.max_step) {
            this.org.extra.setup_wizard.max_step = 1;
        }
        switch (this.currentStep) {
            case Steps.ORG_INFO:
                if (!this.org.extra.details) {
                    this.toaster.pop('warning', 'All fields must be filled in.');
                    return false;
                }
                if (!this.org.name) {
                    return this.validationError('Organisation Name');
                }
                if (!this.org.extra.details.url) {
                    return this.validationError('Website URL');
                }
                if (!this.org.extra.details.industry) {
                    return this.validationError('Industry');
                }
                if (!this.org.extra.details.number_of_employees) {
                    return this.validationError('Number of Employees');
                }
                break;
            case Steps.ORG_ADD_INFO:
                if (!this.org.extra.legal) {
                    this.toaster.pop('warning', 'All fields must be filled in.');
                    return false;
                }
                if (!this.org.extra.legal.type) {
                    return this.validationError('Legal Representative: Type');
                }
                if (this.org.extra.legal.type === this.legal_rep_type_options[0]) {
                    if (!this.org.extra.legal.contact_first_name) {
                        return this.validationError('Legal Representative: First Name');
                    }
                    if (!this.org.extra.legal.contact_last_name) {
                        return this.validationError('Legal Representative: Last Name');
                    }
                    if (!this.org.extra.legal.contact_email) {
                        return this.validationError('Legal Representative: Email');
                    }
                    if (!this.org.extra.legal.contact_phone) {
                        return this.validationError('Legal Representative: Contact Number');
                    }
                }
                if (this.org.extra.legal.type === this.legal_rep_type_options[1]) {
                    if (!this.org.extra.legal.firm_name) {
                        return this.validationError('Legal Representative: Firm Name');
                    }
                    if (!this.org.extra.legal.firm_email) {
                        return this.validationError('Legal Representative: Firm Email');
                    }
                    if (!this.org.extra.legal.firm_phone) {
                        return this.validationError('Legal Representative: Contact Number');
                    }
                }

                if (!this.org.extra.ohs) {
                    this.toaster.pop('warning', 'All fields must be filled in.');
                    return false;
                }
                if (!this.org.extra.ohs.type) {
                    return this.validationError('Health & Safety: Type');
                }
                if (this.org.extra.ohs.type !== this.ohs_rep_type_options[4]) {
                    if (!this.org.extra.ohs.contact_first_name) {
                        return this.validationError('Health & Safety: First Name');
                    }
                    if (!this.org.extra.ohs.contact_last_name) {
                        return this.validationError('Health & Safety: Last Name');
                    }
                    if (!this.org.extra.ohs.contact_email) {
                        return this.validationError('Health & Safety: Email');
                    }
                    if (!this.org.extra.ohs.contact_phone) {
                        return this.validationError('Health & Safety: Contact Number');
                    }
                }
                if (this.org.extra.ohs.type === this.ohs_rep_type_options[3]) {
                    if (!this.org.extra.ohs.contact_other) {
                        return this.validationError('Health & Safety: Please describe');
                    }
                }
                if (!this.org.extra.ohs.done_first_aid_training) {
                    return this.validationError('Health & Safety: First Aid Training');
                }
                if (this.org.extra.ohs.done_first_aid_training === this.first_aid_training_options[0]) {
                    if (!this.org.extra.ohs.last_first_aid_training) {
                        return this.validationError('Health & Safety: Date of First Aid Training');
                    }
                }
                break;

            case Steps.INSURANCE:
                if (!this.org.extra.insurance) {
                    this.toaster.pop('warning', 'All fields must be filled in.');
                    return false;
                }
                if (!this.org.extra.insurance.contact_first_name) {
                    return this.validationError('First Name');
                }
                if (!this.org.extra.insurance.contact_last_name) {
                    return this.validationError('Last Name');
                }
                if (!this.org.extra.insurance.contact_email) {
                    return this.validationError('Email');
                }
                if (!this.org.extra.insurance.contact_phone) {
                    return this.validationError('Contact Number');
                }
                if (!this.org.extra.insurance.medical_renew) {
                    return this.validationError('Medical Renewal Date');
                }
                if (!this.org.extra.insurance.broker_type) {
                    return this.validationError('Broker Type');
                }
                if (this.org.extra.insurance.broker_type === 'Yes') {
                    if (!this.org.extra.insurance.broker_name) {
                        return this.validationError('Broker Name');
                    }
                }
                if (this.org.extra.insurance.broker_type === 'Yes' && this.org.extra.insurance.broker_name === 'Other') {
                    if (!this.org.extra.insurance.broker_other) {
                        return this.validationError('Broker Name');
                    }
                    if (!this.org.extra.insurance.broker_first_name) {
                        return this.validationError('Broker First Name');
                    }
                    if (!this.org.extra.insurance.broker_last_name) {
                        return this.validationError('Broker Last Name');
                    }
                    if (!this.org.extra.insurance.broker_email) {
                        return this.validationError('Broker Email');
                    }
                    if (!this.org.extra.insurance.broker_phone) {
                        return this.validationError('Broker Contact Number');
                    }
                }
                break;
            default: {
                break;
            }
        }
        return true;
    }

    public doit(form: angular.IFormController): void {
        if (!this.org.extra.setup_wizard.max_step) {
            this.org.extra.setup_wizard.max_step = 1;
        }

        switch (this.currentStep) {
            case Steps.TOS: 
                if (this.agree) {
                    this.org.extra.setup_wizard.current_step = Steps.PRIV;
                    this.org.extra.setup_wizard.max_step = Math.max(this.org.extra.setup_wizard.max_step,
                        this.org.extra.setup_wizard.current_step);
                    this.saveOrg();
                    this.acceptToS();
                    this.currentStep = this.org.extra.setup_wizard.current_step;
                } else {
                    this.toaster.pop('warning', 'You must accept the Terms and Conditions');
                }
                break;
            case Steps.PRIV:
                if (this.agreePP) {
                    this.org.extra.setup_wizard.current_step = Steps.ORG_INFO;
                    this.org.extra.setup_wizard.max_step = Math.max(this.org.extra.setup_wizard.max_step,
                    this.org.extra.setup_wizard.current_step);
                    this.saveOrg();
                    this.acceptPrivacyPolicy();
                    this.currentStep = this.org.extra.setup_wizard.current_step;
                } else {
                    this.toaster.pop('warning', 'You must accept the Privacy Policy');
                }
                break;
            case Steps.ORG_INFO:
                if (!this.validateForm()) {
                    return;
                }
                this.org.extra.setup_wizard.primary_hrm = this.employee.id;
                this.org.extra.setup_wizard.completed = true;
                this.org.extra.setup_wizard.max_step = Math.max(this.org.extra.setup_wizard.max_step,
                this.org.extra.setup_wizard.current_step);
                this.saveOrg();
                this.$state.go('home');
                break;
            default: {
                break;
            }
        }
    }

    public cancel(form: angular.IFormController): void {
        this.Login.logout().$promise.then(() => {
            // cleaning user-id attr
            angular.element('body').removeAttr('user-id');

            this.User.clearUser();
            this.$state.go('login');
            this.toaster.pop('warning', 'You must accept the Terms and Conditons');
        });
    }

    public isStepCompleted(step: any): boolean {
        return step <= this.currentStep;
    }

    public gotoStep(step: any): any {
        if (this.org.extra.setup_wizard.max_step) {
            if (step <= this.org.extra.setup_wizard.max_step) {
                this.currentStep = step;
            }
        } else {
            if (step < this.currentStep) {
                this.org.extra.setup_wizard.max_step = this.currentStep;
                this.currentStep = step;
            }
        }
    }

    public acceptToS(): void {
        this.Employee.loadEmployee(this.User.getCurrentUser().userData.id).then((response: Restangular.IResponse) => {
            this.employee = response;
            this.Employee.acceptToS(this.employee).then(() => {
            });
        });
    }

    public acceptPrivacyPolicy(): void {
        this.Employee.loadEmployee(this.User.getCurrentUser().userData.id).then((response: Restangular.IResponse) => {
            this.employee = response;
            this.Employee.acceptPrivacyPolicy(this.employee).then(() => {
            });
        });
    }

    private saveOrg(): void {
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        let url: string = '/api/org';
        this.$http.put(url, this.Api.stripRestangular(this.org)).then((org: any) => {
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            if (this.org.extra.setup_wizard.completed) {
                this.$state.go('home');
            }
        }, (response: any) => {
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            if (response.status === 403) {
                this.toaster.pop('error', 'Access Denied', response.data.detail);
            } else if (response.status === 400) {
                this.toaster.pop('warning', 'Validation Failed', response.data[0] || response.data);
            } else {
                this.toaster.pop('error', 'Server error', 'Please, try again later');
            }
        });
    }

    private saveEmployee(): void {
        this.Employee.updateSelf(this.employee);
    }

}

angular.module('beneple.global')
    .controller('WizardController', WizardController);



// WEBPACK FOOTER //
// ./frontend/scripts/global/controllers/wizard.controller.ts